// auth
export const SIGNUP_URL = "/auth/signup";
export const LOGIN_URL = "/auth/login";
export const GOOGLE_AUTH_URL = "/auth/google";
export const FORGOT_PASSWORD_URL = "/auth/forgotPassword";
// Reset password from the "forgot password" email link (PUT /auth/resetPassword/:token).
export const RESET_PASSWORD_URL = "/auth/resetPassword";
// Reset password after verifying the phone number via Firebase OTP
// (PUT /auth/resetPasswordWithPhone).
export const RESET_PASSWORD_WITH_PHONE_URL = "/auth/resetPasswordWithPhone";
// Staff invite: set initial password and verify the email (PUT /auth/setPasswordAndVerify/:token).
export const SET_PASSWORD_URL = "/auth/setPasswordAndVerify";

// user (team & profile — the self-service endpoints)
export const USER_TEAM_URL = "/user/team";
export const USER_PROFILE_URL = "/user/profile";

// platform accounts (admin-only — every account across all organizations)
export const USER_URL = "/user";
export const USER_TOGGLE_ACTIVE_URL = "/user/isActive";

// verification
export const VERIFICATION_URL = "/verification";
export const VERIFY_TRANSACTION_URL = "/verification/verify";
export const UPDATE_VERIFICATION_STATUS_URL = "/verification/status";
export const TOGGLE_VERIFICATION_IS_ACTIVE_URL = "/verification/isActive";
export const DELETE_VERIFICATION_URL = "/verification";

// bank (recipient) accounts
export const BANK_ACCOUNT_URL = "/recipient-account";
export const TOGGLE_BANK_ACCOUNT_IS_ACTIVE_URL = "/recipient-account/isActive";

// subscription + plans
export const SUBSCRIPTION_URL = "/subscription";
export const SUBSCRIPTION_INITIALIZE_URL = "/subscription/initialize";
export const SUBSCRIPTION_VERIFY_URL = "/subscription/verify";
export const SUBSCRIPTION_PLAN_URL = "/subscription-plan";
export const SUBSCRIPTION_PLAN_TOGGLE_ACTIVE_URL = "/subscription-plan/isActive";

// payments (admin-only — every payment across all organizations)
export const PAYMENT_URL = "/payment";
